module.exports = __webpack_public_path__ + "img/spinning.768d6426.svg";